export const convertInputBufferToString = (inputBuffer) => {
  return inputBuffer.map((key) => key.key).join('');
};

export const convertInputBufferToOriginalString = (inputBuffer) => {
  return inputBuffer.map((key) => key.originalKey).join('');
};
